import React,{useState,useEffect} from "react";
import {useParams} from 'react-router-dom'
import "./NewInfo.css";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Link} from'react-router-dom'
import MainImages from '../../../assets/Yangiliklar/Jpg/innovationHero.jpg'
import innovationBoxImg from "../../../assets/Yangiliklar/Jpg/innovationbox.jpg"
import facebookImg from "../..//..//assets/Yangiliklar/Svg/facebook.svg";
import instagramImg from "../..//..//assets/Yangiliklar/Svg/instagram.svg";
import telegramImg from "../..//..//assets/Yangiliklar/Svg/telegram.svg";
import shareImg from "../..//..//assets/Yangiliklar/Svg/share.svg";
import eye from '../../../assets/Yangiliklar/Svg/eye.svg'
import time from '../../../assets/Yangiliklar/Svg/time.svg'
import innovationRektorImg from "../..//..//assets/Yangiliklar/Jpg/rektor.jpg";


const NewInfo=()=> {
  
  const settings = {
    
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
      speed: 5000,
      autoplaySpeed: 1000,
      cssEase: "linear",
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    
  };
    const[news,setNews]=useState([])
    const LoadNews=async()=>{
      const res=await axios.get('https://afternoon-reaches-98033.herokuapp.com/api/news?language_code=uz')
      setNews(res.data.data)
      console.log()
    }
    useEffect(()=>{
      LoadNews()
    },[news])
  return (
   <div className="HandleInfo">
     <div className="Navigator">
       <div className="Navigator__from"><Link to="/"> Home</Link></div>
       <div className="Navigator__line"></div>
       <div className="Navigator__to">Innovatsion vazirligi...</div>
     </div>
     <div>
     <div className="mainimage">
       <img src={MainImages} alt="" />
     </div>
     
     <div className="NavigMain">
      <div className="NavigMain__social">
        <div className="social__wrapper">
          <img src={facebookImg} alt="" />
        </div>
        <div className="social__wrapper">
          <img src={instagramImg} alt="" />
        </div>
        <div className="social__wrapper">
          <img src={telegramImg} alt="" />
        </div>
        <div className="social__wrapper">
          <img src={shareImg} alt="" />
        </div>
      </div>
       <div className="NavigMain__wrapper">
       <div className="NavigMain__title">Innovatsiya vazirligi hamkorligida matematika olimpiadasi otkazildi</div>
       <div className="NavigMain__subtitle">Mazkur tanlov Oʻzbekiston Respublikasi Vazirlar Mahkamasining “Ilmiy-tadqiqot va innovatsion faoliyatni rivojlantirishning normativ-huquqiy bazasini yanada takomillashtirish chora-tadbirlari togrisida” 2020-yil 9-martdagi 133-son qarorida belgilangan talablarga muvofiq otkaziladi.</div>
       <div className="NavigMain__date">
         <img src={time} alt="" />
         <p>09:41</p>
         <div className="date__line"></div>
         <p>12-April 2022</p>
         <div className="eyed">
           <img src={eye} alt="" />
           <p>123</p>
         </div>
       </div>
       <img src={innovationBoxImg} className='subimg' alt="" />
      <div className="new__description">O‘zbekiston Respublikasi Prezidentining 2020 yil 12 avgustdagi “Kimyo va biologiya yo‘nalishlarida uzluksiz ta’lim sifatini va ilm-fan natijadorligini oshirish chora-tadbirlari to‘g‘risida”gi PQ-4805-son qarorining 9-bandida belgilangan vazifalar ijrosini ta’minlash maqsadida O‘zbekiston Respublikasi Innovatsion rivojlanish vazirligi, Xalq ta’limi vazirligi, Oliy va o‘rta maxsus ta’lim vazirligi, Fanlar akademiyasi bilan birgalikda har yili ilg‘or xorijiy tajriba asosida ta’lim muassasalari uchun kimyo va biologiya fanlaridan o‘quv va ilmiy adabiyotlarni yaratish bo‘yicha milliy tanlov e’lon qiladi.
     <br/> <br/> Tanlovning asosiy maqsadi – respublikamizda xotin-qizlarni ilm-fanga keng jalb qilish, fan-taʼlim va iqtisodiyotning turli tarmoq va sohalarida ilmiy faoliyat bilan shugʻullanayotgan xotin-qizlarning yangi gʻoya va ishlanmalarini har tomonlama qoʻllab-quvvatlash va ragʻbatlantirish, tashabbuskor amaliy va innovatsion loyihalar natijalari boʻyicha iqtisodiyot tarmoqlari va ijtimoiy sohaning mavjud muammolari, real ehtiyojlari hamda hududiy muammolarni hal etishga qaratilgan ilmiy hajmdor mahsulotlar va innovatsion texnologiyalarni yaratishdan iborat.
     </div>
     <div className="subdeshead">Yangi imkoniyatlar sari</div>
      <div className="new__description">Tanlovning asosiy maqsadi – respublikamizda xotin-qizlarni ilm-fanga keng jalb qilish, fan-taʼlim va iqtisodiyotning turli tarmoq va sohalarida ilmiy faoliyat bilan shugʻullanayotgan xotin-qizlarning yangi gʻoya va ishlanmalarini har tomonlama qoʻllab-quvvatlash va ragʻbatlantirish, tashabbuskor amaliy va innovatsion loyihalar natijalari boʻyicha iqtisodiyot tarmoqlari va ijtimoiy sohaning mavjud muammolari, real ehtiyojlari hamda hududiy muammolarni hal etishga qaratilgan ilmiy hajmdor mahsulotlar va innovatsion texnologiyalarni yaratishdan iborat.</div>
      <div className="gorizontal__line"></div>
      </div>
     </div>
     <div className="NewsCarousel">
     <div className='name'>
          <div className="line"></div>
          <p className='titlee'>Boshqa yangiliklar</p>
      </div>
       <div className="carousel">

       <Slider {...settings}>
           {
             news.map((item,index)=>(
               
                <div className='News__card' key={index}>
                <Link to={`/newinfo/${item.id}`}>
            <img src={innovationRektorImg} className='card__img' alt="" />
            <div className='News__card-info'>
            <div className='head'>2022-yil Universitetimizda yangi fakultetlar ochilmoqda</div>
            <div className='description'>{item.title}</div>
            </div>
             </Link> 
             </div>
               
             ))
           }
        </Slider>

       </div>
     </div>
     </div>
   </div>
  )
}

export default NewInfo
